import { IEdgeServers } from '../../core/api/dto/BuffetDishDto'

export const setEdgeServers = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  if (process.env.REACT_APP_TYPE_SERVER === 'MainServer') {
    const deletedItems =
      oldValue
        ?.filter((item) => !newValue.some((i) => i.id === item.id))
        .map((item) => item.guid) || ([] as string[])
    const addedItems = newValue?.map((item) => item.guid) || ([] as string[])

    return { deletedItems, addedItems }
  }
}
